import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { getPlaceComments, expandPlaceComments } from '@app-core/place/actions'
import PlaceComments from './components/PlaceComments'

class PlaceCommentsContainer extends PureComponent {
  componentDidMount() {
    this._getPlaceComments()
  }

  componentDidUpdate(prevProps) {
    const { placeId: prevPlaceId } = prevProps
    const { placeId } = this.props
    if (prevPlaceId !== placeId) {
      this._getPlaceComments()
    }
  }

  _getPlaceComments = () => {
    const { userId, placeId } = this.props
    this.props.getPlaceComments({ userId, placeId })
  }

  _onExpandCommentClicked = () => {
    const { expandPlaceComments, place } = this.props
    expandPlaceComments({ place: place.toJS() })
  }

  render() {
    const { displayCommentIds, totalCommentsCount, isCommentsLoading, hasMoreComments } = this.props
    return (
      <PlaceComments
        totalCommentsCount={totalCommentsCount}
        displayCommentIds={displayCommentIds.toJS()}
        isCommentsLoading={isCommentsLoading}
        expandPlaceComments={this._onExpandCommentClicked}
        hasMoreComments={hasMoreComments}
      />
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userId: state.currentUser.get('userId'),
    totalCommentsCount: state.place.get('totalCommentsCount'),
    displayCommentIds: state.place.get('displayCommentIds'),
    isCommentsLoading: state.place.get('isCommentsLoading'),
    hasMoreComments: state.place.get('hasMoreComments'),
    place: state.place.getIn(['places', ownProps.placeId]),
  }
}

export default connect(mapStateToProps, {
  getPlaceComments,
  expandPlaceComments,
})(PlaceCommentsContainer)
